<template>
  <b-modal
    v-if="modal"
    v-model="modal"
    :width="450"
    @cancel="closeModal"
    @close="closeModal"
  >
    <div class="card-content">
      <div v-if="itineraryService" class="content">
        <p class="is-h2 has-text-weight-bold">Recalculate Price</p>
        <p class="has-text-weight-light mb-5">
          This action will recalculate the price for service
          {{ itineraryService.code }}. Are you sure you want to continue?
        </p>
        <b-radio
          v-for="option in options"
          :key="option.value"
          v-model="selectedOption"
          name="option"
          :native-value="option.value"
          class="mr-5"
        >
          {{ option.text }}
        </b-radio>
      </div>
    </div>
    <footer class="card-footer is-flex is-justify-content-center">
      <BaseButton
        size="large"
        action="secondary"
        class="mr-2"
        @click="closeModal"
      >
        <p slot="text">No, cancel</p>
      </BaseButton>
      <BaseButton
        size="large"
        action="tercery"
        :loading="loading"
        data-action-type="SERVICE:SALES_RECALCULATE"
        @click="calculateSales"
      >
        <p slot="text">Yes, continue</p>
      </BaseButton>
    </footer>
  </b-modal>
</template>

<script>
import BaseButton from "@/components/base-ui/BaseButton.vue";
import { RECALCULATE_OPTIONS } from "@/constants";
import { serviceHelper } from "@/utils/service";

export default {
  name: "RecalculateServiceSalesModal",
  components: { BaseButton },
  props: {
    itineraryService: {
      type: Object,
      default: () => {},
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modal: false,
      loading: false,
      selectedOption: 0,
      serviceHelper: serviceHelper,
    };
  },
  computed: {
    options() {
      const hasError =
        serviceHelper.hasNumPaxError(this.itineraryService) ||
        serviceHelper.hasPriceError(this.itineraryService);
      const end = hasError ? 1 : undefined;
      return RECALCULATE_OPTIONS.slice(0, end);
    },
  },
  watch: {
    itineraryService(newValue) {
      this.modal = newValue != null;
      if (newValue) {
        this.selectedOption = 0;
      }
    },
  },
  methods: {
    async calculateSales() {
      const calculate_prices = Number(this.selectedOption === 0);
      const calculate_sales = Number(this.selectedOption > 0);
      const calculate_costs = Number(this.selectedOption < 0);

      this.loading = true;

      await this.$store.dispatch("itinerary/updateQuoteServices", {
        services: [this.itineraryService],
        calculate_prices,
        calculate_sales,
        calculate_costs,
      });

      this.loading = false;

      this.closeModal();
    },
  },
};
</script>
